import React from 'react';
import { motion } from 'framer-motion';
import StudyPlannerChat from '../components/StudyPlannerChat';

const Planner = () => {
  return (
    <div className="w-full max-w-4xl mx-auto flex flex-col items-center bg-white/80 dark:bg-gray-800/80 rounded-3xl shadow-2xl p-8">
      {/* Header */}
      <div className="text-center mb-8 w-full">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          📋 Study Planner
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Create personalized study plans and get AI-powered recommendations for your learning journey
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full"
      >
        <StudyPlannerChat />
      </motion.div>
    </div>
  );
};

export default Planner; 